module.exports = __webpack_public_path__ + "img/4S.5156259e.png";